<template>
  <page-outline :title="$t('suppliers.supplier_title')">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position:absolute;top:44px;width:100%;">
          <!-- <cm-messages-filter
            v-if="serviceId === services.SUPPLIERS && mode === 2"
            class="researchfilter"
            style="position:relative;z-index:10"
            filterType="group"
            :mode="this.mode"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter> -->
          <cm-messages-filter
            class="researchfilter"
            style="position:relative;z-index:10"
            propedServiceId="8"
            filterType="list"
            :mode="this.mode"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow:hidden;">
        <b-row class="form-group justify-content-start showLargeScreenOnly" v-if="false">
          <b-col cols="1">
            <b-button class="btn" :disabled="activateSpinner"
              @click="refreshInbox()">
              <i class="fa-light fa-rotate-right"></i>
              <span class="fab-label">{{ $t('common.rfrsh') }}</span>
            </b-button>
          </b-col>
          <b-col cols="1" offset-md="6" >
            <b-button variant="primary" :disabled="activateSpinner"
              @click="extractCSV()">
              <i class="fa-light fa-upload"></i>
              <span class="fab-label">{{ $t('common.extract') }}</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position:relative;z-index:10"
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @refreshInbox="refreshInbox()"
                  @extractCSV="exportList()"
                  @applyFilter="applyFilter($event)"
                  buttonCreateSupplier @createSupplier="createSupplier()"
                  propedServiceId="8">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>
            <!-- <b-col cols="2" offset="10">
              <b-button variant="primary" size="lg"
                href="/suppliers/create/">
                <i class="fa-light fa-plus"></i>
                <span>{{$t('suppliers.sup')}}</span>
              </b-button>
            </b-col> -->

            <b-table hover fixed
              v-if="mode === 1 && items.length"
              class="mt-3"
              :items="items"
              :fields="fields"
              :sort-by="sortField"
              ref="tableSuppliersList"
              :id="'table' + '-' + randomString">
              <template #cell(siren)="data" @click="seeSupplierDetails(data.item.consult, 'kycform')">{{ data.value }}</template>
              <template #cell(social_reason)="data" @click="seeSupplierDetails(data.item.consult, 'kycform')">{{ data.value }}</template>
              <template #cell(date)="data" @click="seeSupplierDetails(data.item.consult, 'kycform')">{{ data.value }}</template>
              <template #cell(status_label)="data" @click="seeSupplierDetails(data.item.consult, 'kycform')">{{ data.value }}</template>
              <template #cell(consult)="data"><span class="cursor" @click="seeSupplierDetails(data.value, 'kycform')"><u>{{ $t('common.cnslt') }}</u></span></template>
              <template #cell(validate)="data"><span class="cursor" @click="seeSupplierDetails(data.value, 'details')"><u>{{ $t('common.validate') }}</u></span></template>
            </b-table>

            <b-row class="mt-5">
              <b-col>
                <b-col cols="12">
                  <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
                </b-col>
              </b-col>
              <!-- <b-col cols="2" offset="2">
                <b-button variant="primary" size="lg"
                  href="/suppliers/create/">
                  <i class="fa-light fa-plus"></i>
                  <span>{{$t('suppliers.sup')}}</span>
                </b-button>
              </b-col> -->
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'
import pagination from "@/components/common/pagination.vue"

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import services from '@/helpers/services'
import {statusLabel} from '@/helpers/labels'

export default {
  name: 'SuppliersList',
  components: {
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner,
    'page-outline': PageOutline,
    'cm-pagination': pagination
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    customMobileLayoutStyle () {
      if (this.serviceId === services.SUPPLIERS) {
        return 'height:136px;'
      } else {
        return 'height:90px;'
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return this.$t('Webheader.my_suppliers')
    }
  },
  data () {
    return {
      activateSpinner: false,
      activateSpinnerGroup: false,
      filterBy: '',
      fields: [
        // { key: 'id_seller', label: this.$t('common.date'), class: 'text-center' },
        { key: 'siren', label: this.$t('common.srn'), class: 'text-center' },
        { key: 'social_reason', label: this.$t('administration.company_name'), class: 'text-center' },
        { key: 'date', label: this.$t('common.creation_date'), class: 'text-center' },
        { key: 'status_label', label: this.$t('common.kyc_status'), class: 'text-center' },
        { key: 'consult', label: 'Consultation', class: 'text-center' },
        { key: 'validate', label: 'Validation', class: 'text-center' }
      ],
      icon: 'help',
      inboxMessages: [],
      completeList: [],
      items: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t('common.appname'),
      services: services,
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig,
      sortField: 'debtor_name',
      randomString: '',
      reload: false
    }
  },
  created () {
    this.reload = false
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.listTitle,
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    //this.paginationObject['refresh'] = this.onRefresh
    this.paginationObject['refresh'] = 'supplier-page'
    this.$bus.$off('supplier-page')
    this.$bus.$on('supplier-page', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
  },
  beforeDestroy () {
    let that = this
    if (that.serviceId !== services.SUPPLIERS) {
      that.$engine.services.suppliers.filter.cleanFilterCondition()
    }
  },
  methods: {
    createSupplier () {
      loadPage(this, {url: '/suppliers/create/'})
    },
    applyFilter (filterConditions, index = 1) {
      console.log('---', filterConditions)
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      if (this.mode === 2) {
        if (this.serviceId === services.SUPPLIERS) {
          this.activateSpinnerGroup = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          this.getRTPGroup(filterConditions)

        }
      } else {
        this.activateSpinner = true
        this.$engine.services.suppliers.update(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Sellers.length
          // requests = resp.data.suppliers
          // list = resp.data.suppliers
          requests = resp.data.Sellers
          this.updateItems(requests)
          this.updateInbox(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
          this.activateSpinner = false
        })
        .catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
      }
    },
    attachInfinit () {
      this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportList () {
      let filterConditions = {}
      if (this.reload) {
        filterConditions = this.$engine.services.suppliers.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.services.suppliers.filter.getDefaultFilter()
      }
      this.$engine.services.suppliers.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportSellers
        this.updateList(list)
        this.extractCSV(this.completeList)
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractCSV (inboxMessages) {
        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
        let firstLine = this.$t('common.srn') + ';' +
          this.$t('administration.company_name') + ';' +
          this.$t('common.creation_date') + ';' +
          this.$t('common.kyc_status') + '\r\n'
        let line = atob(this.completeList.result)
        let data = firstLine + line
        this.$f7.hidePreloader()
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = 'Suppliers_' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
    },
    goBack (url) {
      if (url !== 'none') {
        loadPage(this, {url: url})
      } else {
        /* On évite d'afficher la page de login a un utilisateur deja connecte */
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          this.$bus.$emit('router-back')
          this.$f7.mainView.router.back()
        }
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0
        if (this.mode === 2) {
          if (this.serviceId === services.PAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services.payments.filterGroup.getDefaultFilter()) {
              filterConditions = this.$engine.services.payments.filterGroup.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services.payments.filterGroup.getConditionObject()
            }
          }
        } else {
          let filterConditions
          if (this.$engine.services.payments.filter.getDefaultFilter()) {
            filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services.payments.filter.getConditionObject()
          }
          this.$engine.services.payments.update(
            this.direction,
            this.paginationObject['maxResults'],
            this.paginationObject['firstIndex'],
            filterConditions
          ).then(resp => {
            let requests = {}
            that.paginationObject.nbResults = that.requestsNumber

            if (requests.length > 0) {
              for (let i = 0; i < requests.length; i++) {
                that.inboxMessages.push(requests[i])
              }
              if (requests.length < this.paginationObject['maxResults']) {
                that.detachInfinit()
              }
            } else {
              that.detachInfinit()
            }
            that.scrollFlag = true
          })
          .catch(error => {
            errorMessageAlert(error, that, that.$i18n)
            that.scrollFlag = true
          })
        }
      }
    },
    onRefresh (noAttach = false, index = 1) {
      // const that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      let filterConditions
      // if (this.$engine.services.suppliers.filter.getDefaultFilter()) {
      //   filterConditions = this.$engine.services.suppliers.filter.getDefaultFilter()
      //   console.log('filter', filterConditions)
      // } else {
      //   filterConditions = this.$engine.services.suppliers.filter.getConditionObject()
      // }
      if (this.reload) {
        filterConditions = this.$engine.services.suppliers.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.services.suppliers.filter.getDefaultFilter()
      }
      this.$engine.services.suppliers.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.Sellers.length
        requests = resp.data.Sellers

        this.updateItems(requests)
        this.updateInbox(requests, noAttach)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      console.log('filter', this.$engine.services.suppliers.filter.getConditionObject(), this.$engine.services.payments.filter.getDefaultFilter())
      // if (this.$engine.services.payments.filter.getDefaultFilter()) {
      //   this.reload = false
      // } else {
      //   this.reload = true
      // }
      this.onRefresh()
    },
    seeSuppliersKYCForm (data) {
      if (data && data[0]) {
        this.$engine.services.suppliers.selectedSupplier = _.cloneDeep(data[0].consult)
        this.$refs['tableSuppliersList'].clearSelected()
        loadPage(this, { url: '/suppliers/kycform/' })
      }
    },
    seeSupplierDetails (seller, action) {
      this.$engine.services.suppliers.selectedSupplier = seller
      switch (action) {
        case 'kycform':
          loadPage(this, { url: '/suppliers/kycform/' })
          break
        case 'details':
          loadPage(this, { url: '/suppliers/details/' })
          break
        case 'docform':
          loadPage(this, { url: '/suppliers/docform/' })
          break
        default:
          loadPage(this, { url: '/suppliers/details/' })
          break
      }
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (requests) {
      this.completeList = requests
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {

        let date = ''
        date = requests[i].Date

        if (date !== '') {
          date = moment(date).format('DD/MM/YYYY')
        }

        let status_label = ''
        status_label = statusLabel(this.$i18n, "Provider_" + requests[i].Status)

        let result = {
          bic: requests[i].Bic,
          country: requests[i].Country,
          company_creation_date: requests[i].CreationDate,
          date: date,
          email: requests[i].Email,
          group_doc_id: requests[i].GroupDocumentId,
          iban: requests[i].Iban,
          id_group_doc: requests[i].IdGroupDocument,
          id_seller: requests[i].IdSeller,
          id_read: requests[i].IsRead,
          legal_form: requests[i].LegalForm,
          legal_rep_first_name: requests[i].LegalRepresentativeFirstName,
          legal_rep_last_name: requests[i].LegalRepresentativeLastName,
          naf_code: requests[i].NAFCode,
          name: requests[i].Name,
          opening_status: requests[i].OpeningStatus,
          owner: requests[i].Owner,
          postal_code: requests[i].PostalCode,
          reference: requests[i].Reference,
          seller_identifier: requests[i].SellerIdentifier,
          siren: requests[i].Siren,
          siret: requests[i].Siret,
          social_reason: requests[i].SocialReason,
          solde: requests[i].Solde,
          status_label: status_label,
          street_name: requests[i].StreetName,
          total_awaiting_documents: requests[i].TotalAwaitingDocuments,
          total_documents: requests[i].TotalDocuments,
          total_to_validate_doc: requests[i].TotaltoValidateDocuments,
          town: requests[i].TownName,
          user_id: requests[i].UserIdentifier,
          user_id_2: requests[i].UserIdentifier2,
          consult: requests[i],
          validate: requests[i]
        }
        this.items.push(result)
      }
    }
  }
}
</script>
